import API from "../../../../../global/api";


export const requestGetLevelOne = () => {
    return {
        type: "REQUEST_GET_LEVELONE",
    };
};
export const successGetLevelOne = (data) => {
    return {
        type: "SUCCESS_GET_LEVELONE",
        payload: data,
    };
};
export const errorGetLevelOne = () => {
    return {
        type: "ERROR_GET_LEVELONE",
    };
};
export const GetLevelOneApi = () => {
    return (dispatch) => {
        dispatch(requestGetLevelOne());
        API.get(`/levelOne/get_all_levelone`).then((res) => {
            let getData = res.data;
            dispatch(successGetLevelOne(getData));
        }).catch((error) => {
            dispatch(errorGetLevelOne());
        })
    };
};